import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const InfoContainer = styled.div`
  display: flex;
  margin-bottom: 32px;
  margin-left: 32px;

  @media ${({ theme }) => theme.device.desktop} {
    margin-left: 24px;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 48px;
  width: 16px;
  margin-right: 32px;
`;

export const Content = styled.div`
  margin-right: 32px;
`;

export const Title = styled.div`
  padding: 0px;
  max-height: 48px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  color: ${ColorPalette.HEX.PineTree};
`;

export const Info = styled.div`
  padding: 0px;
  font-family: Poppins;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.1px;
  color: ${ColorPalette.HEX.DimGray};
`;
